var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Seguimiento de paquetes")]),_vm._v(" "),_c('status-filter',{on:{"change":_vm.getpackages}}),_vm._v(" "),_c('table-actions',{attrs:{"tableHeaders":_vm.headers,"tableData":_vm.packages,"title":_vm.title,"showSelect":false,"showSubSelect":false,"showSubTable":true,"subTableHeaders":_vm.subtableHeaders},on:{"aproved":_vm.aprovedPackage,"addPayment":_vm.addPayment}}),_vm._v(" "),(_vm.showDialog)?_c('simple-modal',{on:{"close":function($event){_vm.showDialog = false}}},[_c('add-payment',{attrs:{"package":_vm.packageId},on:{"success":_vm.success}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/extranet/PackageTracking.vue